import React, { useEffect, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap';
import {
    dateTimeFormatGlobalSet, getError, isUndNullEmpNew, sendMessageCloseCurrentWindow, setSeparatorsNumbers, settings, getLanguageObj, getResponse
} from '../../helpers/UtilsHelper';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AuthContextType } from '../../auth/AuthContext';

const { app, icons, images, labels, mercadoLibre } = settings;
const { feedback: mercadoLibreFeedback, } = mercadoLibre;

const currentMethod = 'SaleEditDetails - function';

export default function SaleEditDetails({
    processValues = {},
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const {
        auth = AuthContextType,
        dateTimeFormat = '',
        sale = {
            buyer: { nickname: '', first_name: '', last_name: '' },
            date_created: '',
            feedbackFull: {
                purchase: { message: '', rating: '' },
                sale: { message: '', rating: '' },
            },
            order: '',
            order_items: [
                { item: { id: '', title: '', picture: '' }, quantity: 0.00, unit_price: 0.00, full_unit_price: 0.00, },
            ],
            type: 0,
        },
        type = 0,
        setSaleEdited = () => { },
        setSaleEditedInit = () => { },
        showModal = false,
        setShowModal = () => { },
    } = processValues;

    const [itemPicture, setItemPicture] = useState('');
    const [feedbackBuyerType, setFeedbackBuyerType] = useState('');
    const [feedbackSellerType, setFeedbackSellerType] = useState('');
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const setDefaultValue = ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            setSaleEdited(setSaleEditedInit());
            setShowModal(!isModalClose);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console?.error(response);
        }
        return response;
    }

    const setRating = ({
        data = '',
        subMethod = '',
    }) => {
        const currentMethod = 'setRating';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            if (!isUndNullEmpNew({ data: data, subMethod: currentMethod })?.result) {
                switch (data) {
                    case mercadoLibreFeedback?.ratings?.negative:
                        response.result = `${icons?.fasFa?.minusCircle} text-danger`;
                        break;
                    case mercadoLibreFeedback?.ratings?.neutral:
                        response.result = `${icons?.fasFa?.pauseCircle} text-info`;
                        break;
                    case mercadoLibreFeedback?.ratings?.positive:
                        response.result = `${icons?.fasFa?.plusCircle} text-success`;
                        break;
                    default:
                        break;
                }
            } else {
                response.result = `${icons?.fasFa?.stopCircle} text-secondary`;
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console?.error(response);
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            setFeedbackBuyerType(setRating({
                data: sale?.feedbackFull?.purchase?.rating || '',
                subMethod: currentMethod
            })?.result);
            setFeedbackSellerType(setRating({
                data: sale?.feedbackFull?.sale?.rating || '',
                subMethod: currentMethod,
            })?.result);
            setItemPicture(
                sale?.order_items?.[0]?.item?.picture ||
                `${app?.url}${images?.noImage}`
            );
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal id='saleEditDetailsModal'
            backdrop='static'
            onHide={() => setDefaultValue({ isModalClose: true, subMethod: 'onHide - modal' })}
            show={showModal}
            centered
            contentClassName='border-0 shadow-lg login-card'>

            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt={labels?.details?.[languageObj?.id]} src={images?.icons?.store}
                        style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.sales?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase ${type === 1 ? 'badge-warning text-dark' : 'badge-info'}`}
                            style={settings?.html?.badges?.micro}>
                            {type === 1 ? labels?.edit?.[languageObj?.id] : labels?.detail?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className='px-4 pt-0 pb-4'>
                <div className='text-center mb-4 mt-2'>
                    <img alt='itemImage' className='img-circle shadow-sm border' src={itemPicture} style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                    <h6 className='mt-3 mb-1 font-weight-bold text-dark'>{sale?.order_items?.[0]?.item?.title}</h6>
                    <small className='text-muted d-block'>{sale?.order_items?.[0]?.item?.id}</small>
                </div>

                <div className='row'>
                    {[
                        { label: labels?.date?.[languageObj?.id], value: dateTimeFormatGlobalSet(sale?.date_created, dateTimeFormat, 24, false, false)?.result || '---', icon: icons?.faFa?.calendarAlt, color: 'info', wide: false },
                        { label: labels?.quantity?.[languageObj?.id], value: setSeparatorsNumbers(sale?.order_items?.[0]?.quantity, true)?.result || '---', icon: icons?.fasFa?.sortNumericUpAlt, color: 'primary', wide: false },
                        { label: labels?.priceOC?.[languageObj?.id], value: setSeparatorsNumbers(sale?.order_items?.[0]?.full_unit_price, true)?.result || '---', icon: icons?.dollarSign, color: 'primary', wide: false },
                        { label: labels?.price?.[languageObj?.id], value: setSeparatorsNumbers(sale?.order_items?.[0]?.unit_price, true)?.result || '---', icon: icons?.moneyBillWave, color: 'primary', wide: false },
                        { label: labels?.buyer?.[languageObj?.id], value: `${sale?.buyer?.nickname} - ${sale?.buyer?.first_name}, ${sale?.buyer?.last_name}`, icon: icons?.fasFa?.user, color: 'primary', wide: true },
                        { label: labels?.order?.[languageObj?.id], value: sale?.order || '---', icon: icons?.fasFa?.hashTag, color: 'primary', wide: true },
                    ].map((field, idx) => (
                        <div key={idx} className={`col-12 col-md-${field.wide ? '12' : '6'} mb-3`}>
                            <div className={`p-3 rounded bg-light border-left border-${field.color || 'primary'} shadow-sm h-100`}
                                style={{ borderLeftWidth: '5px' }}>
                                <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                    style={settings?.html?.labels?.detailMicro}>
                                    {field.icon && <i className={`${field.icon} mr-1`} />} {field.label}
                                </small>
                                <span className='text-dark font-weight-bold'>{field.value}</span>
                            </div>
                        </div>
                    ))}

                    {/* Feedback section */}
                    {/* <div className='col-12 col-md-6 mb-3'>
                        <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                <i className={`${icons?.fasFa?.userTie} mr-1`} /> {labels?.seller?.[languageObj?.id]} <i className={`${feedbackSellerType} ml-1`}></i>
                            </small>
                            <span className='text-dark font-weight-bold'>{sale?.feedbackFull?.sale?.message || '---'}</span>
                        </div>
                    </div>
                    <div className='col-12 col-md-6 mb-3'>
                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.buyer?.[languageObj?.id]} <i className={`${feedbackBuyerType} ml-1`}></i>
                            </small>
                            <span className='text-dark font-weight-bold'>{sale?.feedbackFull?.purchase?.message || '---'}</span>
                        </div>
                    </div> */}
                    <div className='col-12 col-md-12 mb-3'>
                        <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                <i className={`${icons?.fasFa?.userTie} mr-1`} /> {labels?.seller?.[languageObj?.id]} <i className={`${feedbackSellerType} ml-1`}></i>
                            </small>
                            <span className='text-dark font-weight-bold'>{sale?.feedbackFull?.sale?.message || '---'}</span>
                        </div>
                    </div>
                    <div className='col-12 col-md-12 mb-3'>
                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.buyer?.[languageObj?.id]} <i className={`${feedbackBuyerType} ml-1`}></i>
                            </small>
                            <span className='text-dark font-weight-bold'>{sale?.feedbackFull?.purchase?.message || '---'}</span>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                <div className='d-flex justify-content-center w-100'>
                    <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                        type='button'
                        onClick={() => setDefaultValue({ isModalClose: true, subMethod: 'btnFooter - modal' })}>
                        <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}